// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"41d4e01c","86":"385e6567","794":"70e6b63d","829":"385e6567"}[chunkId] + ".chunk.css";
};